import { confirmTimeSlot } from '~/src/entities/speed-bonus/context/actions/thunk';
import { useContextDispatch } from '~/src/entities/speed-bonus/context/hooks';

import ErrorResult from './index';

const ErrorRequest = (): JSX.Element => {
    const ctxDispatch = useContextDispatch();

    const tryAgain = () => {
        ctxDispatch(confirmTimeSlot());
    };

    return (
        <ErrorResult onRetry={tryAgain}/>
    );
};

export default ErrorRequest;
